module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_4.5c8eb589.svg";